import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import VideoFileOutlinedIcon from "@mui/icons-material/VideoFileOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const fileIcon = (fileName: string) => {
  if (fileName.includes("pdf")) {
    return (
      <PictureAsPdfOutlinedIcon
        sx={{ width: "65%", height: "65%", color: "#303d41" }}
      />
    );
  }

  if (
    fileName.includes("jpeg") ||
    fileName.includes("jpg") ||
    fileName.includes("png")
  ) {
    return (
      <InsertPhotoIcon sx={{ width: "65%", height: "65%", color: "#303d41" }} />
    );
  }

  if (fileName.includes("rar")) {
    return (
      <Inventory2OutlinedIcon
        sx={{ width: "65%", height: "65%", color: "#303d41" }}
      />
    );
  }

  if (fileName.includes("mp4")) {
    return (
      <VideoFileOutlinedIcon
        sx={{ width: "65%", height: "65%", color: "#303d41" }}
      />
    );
  }

  return (
    <DescriptionOutlinedIcon
      sx={{ width: "65%", height: "65%", color: "#303d41" }}
    />
  );
};
